<template lang="pug">
    el-button.ButtonSend(@click="check" type="success" :disabled="isDisabled" v-if="show") Revisar
</template>
<script>

import { mapGetters, mapMutations } from 'vuex';
import checkFunctions from '@/utils/checkFunctions';
import { debug } from 'util';

export default {
  name: 'ButtonSend',
  computed: {
    ...mapGetters(['currentStep'])
  },
  
  data() {
    return {
      isDisabled: true,
      show: true
    }
  },
  watch: {
    currentStep: {
      handler(val){        
        this.isDisabled = !val.answered;
        this.show = ((val.check || false) === false);
      },
      deep: true
    }
  },
  mounted:function(){
    this.show = true;
    this.isDisabled = true;
  },
  methods: {
    check() {      
      const check = checkFunctions[this.currentStep.checkFunction];
      this.currentStep.points = check(this.currentStep);      
      this.currentStep.check = true;
    }
  },
}
</script>

<style scoped>
@import 'button-send.scss';
</style>

